import { connect } from 'react-redux'
import { getPhoto } from '@selectors/data/photo_selectors.js'

const mapStateToProps = (state, props) => {
  const { value } = props
  const photo = getPhoto(state, { photoId: value })
  return {
    photo,
    ...props,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {}
}

// This is a higher-order component that wraps a component that renders a value
const withPhoto = WrappedComponent => {
  return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent)
}

export default withPhoto
